export default {
    token: ''
}
